export const convertBytesToHumanReadable = (bytes: number) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString())

  return (Math.round(bytes / Math.pow(1024, i) * 100) / 100) + ' ' + sizes[i]
}

export const lowerFirstLetter = (string: string) => {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

export const upperFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const convertMinutesToHoursAndMinutes = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  return {
    hours,
    minutes: remainingMinutes
  }
}

export const convertMinutesToHoursAndMinutes2Digit = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: remainingMinutes.toString().padStart(2, '0')
  }
}
